import React from 'react';
import { track } from '@amplitude/analytics-browser';
import { Box, Card, Text, Title, Toggle } from '@nimbus-ds/components';
import { PaymentMethodsType } from 'commons/types';
import { useTranslationWithPrefix } from 'commons/utils';

type PaymentMethod = {
  enabled: boolean;
  paymentMethod: PaymentMethodsType;
};

interface PaymentMethodCardProps {
  method: PaymentMethod;
  onCheckPaymentMethod: (
    enabled: boolean,
    paymentMethod: PaymentMethodsType,
  ) => void;
  getPaymentMethodContent: (
    method: PaymentMethodsType,
  ) => React.ReactNode | undefined;
  disabled?: boolean;
}

function PaymentMethodCard({
  method,
  onCheckPaymentMethod,
  getPaymentMethodContent,
  disabled,
}: PaymentMethodCardProps): JSX.Element {
  const { t } = useTranslationWithPrefix('paymentMethods');

  const content = getPaymentMethodContent(method.paymentMethod);

  const onToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.currentTarget.checked;
    track(`pagonube_config_mediosdepago_${method.paymentMethod}_click`, {
      enabled: checked,
    });
    onCheckPaymentMethod(checked, method.paymentMethod);
  };

  return (
    <Card>
      <Card.Header>
        <Box display="flex" flexDirection="row" justifyContent="space-between">
          <Title as="h4">{t(method.paymentMethod)}</Title>
          <Toggle
            checked={method.enabled}
            onChange={onToggle}
            name={method.paymentMethod}
            disabled={disabled}
          />
        </Box>
        {disabled && (
          <Box marginTop="2">
            <Text fontSize="caption">
              {t('disableCreditCardWithMetaplanError')}
            </Text>
          </Box>
        )}
      </Card.Header>
      {content && <Card.Body>{content}</Card.Body>}
    </Card>
  );
}

export default PaymentMethodCard;
